import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

/** Store-scoped keys: switching stores never shares cache. */
export const jobKeys = {
  exports: (storeId: string) => ['stores', storeId, 'exports'] as const,
  exportList: (storeId: string, params: ListParams) =>
    [...jobKeys.exports(storeId), 'list', params] as const,
  // Outside `exports`/`imports` so a list invalidation never refetches the job being polled.
  exportTracking: (storeId: string) => ['stores', storeId, 'export-tracking'] as const,
  importTracking: (storeId: string) => ['stores', storeId, 'import-tracking'] as const,
  imports: (storeId: string) => ['stores', storeId, 'imports'] as const,
  importList: (storeId: string, params: ListParams) =>
    [...jobKeys.imports(storeId), 'list', params] as const,
  importDetail: (storeId: string, id: string) =>
    [...jobKeys.imports(storeId), 'detail', id] as const,
};
